<div class="details" *ngIf="functie && cmsContent">

  <div class="row">
    <div class="details__content-container col-xs-12 col-sm-12 col-md-12 col-lg-12">
      <div class="details__back">
        <a (click)="back()">
          <mat-icon>arrow_back</mat-icon>
          <p>{{'functie-details.back' | content}}</p>
        </a>
      </div>
      <h1 class="details__title">{{functie.naam}}</h1>
      <div class="details__bullits">
        <div class="details__properties">
          <div class="details__bullits-item">
            <mat-icon class="material-icons">school</mat-icon>
            <p>{{opleidingsniveaus}}</p>
          </div>
          <div class="details__bullits-item" *ngIf="functie.salaris.gte > 0 && functie.salaris.lte > 0">
            <mat-icon class="material-icons">euro_symbol</mat-icon>
            <p>{{functie.salaris.gte}} - {{functie.salaris.lte}}</p>
          </div>
        </div>
      </div>

      <p class="details__omschrijving">
        {{functie.omschrijving}}
      </p>

      <div class="details__share-container">
        <app-share mode="functie" [functieSlug]="functie.slug" *ngIf="mode !== 'selector'"></app-share>
      </div>

      <button class="details__cta-button"
              data-cy="naarVacatureSiteCTA"
              *ngIf="functie.linkVacatures && mode !== 'selector'"
              (click)="handleGotoVacancySite()">
        {{ cmsContent.naarVacatureSiteCtaLabel }}
      </button>

      <button class="details__select-button"
              *ngIf="mode === 'selector'"
              data-cy="SelecteerFunctieInDetailsKnop"
              (click)="handleSelect()">
        {{ 'functie-details.ditIsMijnFunctie' | content }}
      </button>
    </div>
  </div>

  <div data-cy="details__extended" *ngIf="showExtendedDetails">
    <div class="details__grid" >
      <div class="row pre-wrap" [attr.id]="'waarom'">
        <div class="details__waarom col-xs-12 col-sm-12 col-md-7 col-lg-7">
          <app-accordion-compact [open]="true">
            <h2 accordionHeader>{{ cmsContent.waaromPastFunctieTitle }}</h2>
            <ng-container accordionBody>
              <p>{{functie.pastFunctieBijJou}}</p>
            </ng-container>
          </app-accordion-compact>
        </div>
      </div>

      <div class="row" [attr.id]="'watDoeJe'">
        <div class="details__wat-doe-je col-xs-12 col-sm-12 col-md-7 col-lg-7">
          <app-accordion-compact [open]="true">
            <h2 accordionHeader>{{ cmsContent.watDoeJeInFunctieTitle }}</h2>
            <ng-container accordionBody>
              <ul>
                <li data-cy="kerntaken" class="details__kerntaken" *ngFor="let kerntaak of functie.kerntaken">
                  <mat-icon class="details__kerntaken--icon">
                    check
                  </mat-icon>
                  <p>{{kerntaak.naam}}</p>
                </li>
              </ul>
            </ng-container>
          </app-accordion-compact>
        </div>
      </div>

      <div class="row" [attr.id]="'kenmerken'">
        <div class="details__kenmerken col-xs-12 col-sm-12 col-md-7 col-lg-7">
          <app-accordion-compact [open]="false">
            <h2 accordionHeader>{{ cmsContent.voorkeurenTitle }}</h2>
            <ng-container accordionBody>
              <div [innerHTML]="cmsContent.voorkeurenDescription"></div>
              <div *ngFor="let interest of this.interests">
                <ng-container *ngIf="interest.length > 0">
                  <div class="interest">
                    <h3 class="interest__title-block">{{interest[0].type}}</h3>
                    <app-interest-selector
                      mode="read-only"
                      [interests]="interest">
                    </app-interest-selector>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </app-accordion-compact>
        </div>
      </div>
    </div>

    <div class="details__grid"
         *ngIf="mode !== 'selector' && functie.arbeidsmarktPerspectief"
         [attr.id]="'arbeidsmarktperspectief'">
      <div class="row">
        <div class="details__arbeidsmarktinformatie col-xs-12 col-sm-12 col-md-7 col-lg-7">
          <app-accordion-compact [open]="false">
            <h2 accordionHeader>{{ cmsContent.arbeidsmarktTitle }}</h2>
            <ng-container accordionBody>
              <div #arbeidsmarktinformatie></div>
            </ng-container>
          </app-accordion-compact>
        </div>
      </div>
    </div>

    <div class="details__grid"
         *ngIf="mode !== 'selector' && !functie.toekomstfunctie && functie.toekomstfunctieId"
         [attr.id]="'toekomstFuncties'">
      <div class="row">
        <div class="details__toekomst col-xs-12 col-sm-12 col-md-7 col-lg-7">
          <app-accordion-compact [open]="true">
            <h2 accordionHeader>{{ cmsContent.toekomstVanFunctieTitle}}</h2>
            <ng-container accordionBody>
              <p>{{functie.toekomstperspectief}}</p>
              <div class="details__toekomst-button-container">
                <h3 [innerHTML]="cmsContent.toekomstVanFunctieSubtitle"></h3>
                <button data-cy="compareWithToekomstFunctie"
                        class="details__toekomst-button"
                        *ngIf="functie.toekomstfunctieId"
                        (click)="compareWithToekomstFunctie()">
                  {{ 'functie-details.vergelijkFuncties' | content }}
                </button>
              </div>
            </ng-container>
          </app-accordion-compact>
        </div>
      </div>
    </div>

    <div data-cy="competenties" class="details__competenties" [attr.id]="'competenties'">

      <div class="details__title-block">
        <h2>{{ cmsContent.kennisVaardighedenTitle }}</h2>
      </div>

      <div class="lijst-row" *ngIf="view === compareEnum.Kompas">
        <div class="lijst-col lijst-col-2">
          <app-radar-chart *ngIf="competentieClusters.length > 0"
                           [showLegend]="false"
                           [showCursor]="false"
                           (axisSelected)="handleAxisSelect($event)"
                           [data]="competentieClusters"
                           uuid="functie-detail-radar">
          </app-radar-chart>
        </div>

        <div class="lijst-col lijst-col-1">
          <app-competence-list [selectedCluster]="selectedCluster"
                               [descriptionContent]="cmsContent.kennisVaardighedenDescription">
          </app-competence-list>
        </div>
      </div>
    </div>

    <div class="details__lanes" >
      <div class="row">
        <div [attr.id]="'cursorischeOpleidingen'"
             *ngIf="mode === 'default' && opleidingen && opleidingen.cursorischeOpleidingen?.length > 0"
             class="details__cursorische-opleidingen">

          <h2>{{ 'functie-details.cursusLaanTitel' | content }}</h2>

          <app-lane mode="opleiding"
                    [opleidingen]="opleidingen.cursorischeOpleidingen">
          </app-lane>
        </div>
      </div>

      <div class="row">
        <div [attr.id]="'beroepsopleidingen'"
             *ngIf="mode === 'default' && opleidingen && opleidingen.beroepsopleidingen?.length > 0"
             class="details__beroepsopleidingen">

          <h2>{{ cmsContent.beroepsOnderewijsLaneTitle }}</h2>

          <app-lane mode="opleiding"
                    [opleidingen]="opleidingen.beroepsopleidingen">
          </app-lane>
        </div>
      </div>

      <div class="row">
        <div [attr.id]="'specialiserendeOpleidingen'"
             *ngIf="mode === 'default' && opleidingen && opleidingen.specialiserendeOpleidingen?.length > 0"
             class="details__specialiserende-opleidingen">

          <h2>{{ 'functie-details.specilisatiesLaanTitel' | content }}</h2>

          <app-lane mode="opleiding"
                    [opleidingen]="opleidingen.specialiserendeOpleidingen">
          </app-lane>
        </div>
      </div>

      <div class="row">
        <div [attr.id]="'verwanteFuncties'"
             *ngIf="mode === 'default'"
             class="details__verwante-functies">

          <h2>
            {{ cmsContent.verwanteFunctiesLaneTitle }}
          </h2>

          <app-lane mode="functie"
                    functieCardMode="DETAIL"
                    (select)="loadFunctie($event)"
                    [functies]="verwanteFuncties">
          </app-lane>
        </div>
      </div>

      <div class="row" *ngIf="vervolgFuncties?.length > 0">
        <div [attr.id]="'vervolgFuncties'"
             *ngIf="mode === 'default'"
             class="details__vervolg-functies">

          <h2>{{ cmsContent.vervolgFunctiesLaneTitle }}</h2>

          <app-lane mode="functie"
                    functieCardMode="DETAIL"
                    (select)="loadFunctie($event)"
                    [functies]="vervolgFuncties">
          </app-lane>
        </div>
      </div>

    </div>
  </div>
</div>
